import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Profile Images' },
    { value: 2, label: 'Bulk Replace' },
    { value: 3, label: 'Profile Images Jurisdictional ID' },
  ],
});
